<template>
  <div>
    <div v-if="pdceneozaufaneopiniepro.show" class="mb-1 pd-ceneo-consent">
      <div class="form-check">
        <input id="pdceneozaufaneopiniepro" type="checkbox" class="form-check-input" :checked="pdceneozaufaneopiniepro.checked" @change="updateValue">
        <label class="form-check-label" for="pdceneozaufaneopiniepro">
          <span v-html="pdceneozaufaneopiniepro.text"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      pdceneozaufaneopiniepro: state => state.PdCeneoZaufaneOpiniePro,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('PdCeneoZaufaneOpiniePro/SET', e.target.checked);
    },
  },
};
</script>